class CircleMenu extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('pointerdown', this.startDrag, options);
    this.addEventListener('pointermove', this.moveDrag, options);
    this.addEventListener('pointerup', this.endDrag, options);
    this.addEventListener('pointercancel', this.endDrag, options);
    this.addEventListener('lostpointercapture', this.endDrag, options);
    this.addEventListener('dragstart', (event) => event.preventDefault(), options);
    this.addEventListener('click', this.handleClick, { ...options, capture: true });
    this.addEventListener('shopify:block:select', this.revealBlock, options);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.pointerId = undefined;
    this.removeAttribute('data-dragging');
  }

  startDrag = (event) => {
    this.dragged = false;
    if (event.pointerType !== 'mouse' || event.button !== 0 || event.ctrlKey || event.metaKey) return;
    if (this.scrollWidth <= this.clientWidth) return;
    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScroll = this.scrollLeft;
  };

  moveDrag = (event) => {
    if (event.pointerId !== this.pointerId) return;
    if (event.buttons !== 1) {
      this.endDrag(event);
      return;
    }
    const delta = event.clientX - this.startX;
    if (!this.dragged && Math.abs(delta) < 6) return;
    if (!this.dragged) {
      this.dragged = true;
      this.setAttribute('data-dragging', '');
      this.setPointerCapture(event.pointerId);
    }
    event.preventDefault();
    this.scrollLeft = this.startScroll - delta;
  };

  endDrag = (event) => {
    if (event.pointerId !== this.pointerId) return;
    this.pointerId = undefined;
    this.removeAttribute('data-dragging');
    if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
  };

  handleClick = (event) => {
    if (this.dragged && event.detail > 0) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.dragged = false;
  };

  revealBlock = (event) => {
    event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
  };
}

if (!customElements.get('circle-menu')) customElements.define('circle-menu', CircleMenu);
